////////////////
// Imports
////////////////
import modular from "modujs";

import globals from "./globals";
import * as modules from "./modules";

import { html } from "./utils/environment";
import { styleSheetsLoader } from "./utils/styleSheetsLoader";
import { fontsLoader } from "./utils/fontsLoader";
import { preloadImages } from "./utils/image";
import debounce from "./utils/debounce";

////////////////
// Settings
////////////////
// Fonts
const fonts = [
    { name: "Euclid Circular B", style: "normal", weight: "normal" },
    { name: "Heldane Display", style: "normal", weight: "normal" },
    { name: "Heldane Text", style: "normal", weight: "normal" },
    { name: "Heldane Text", style: "italic", weight: "normal" },
];

// Modules
const app = new modular({
    modules: modules,
});

// Mobile
const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

////////////////
// Hooks
////////////////
const onFontsLoaded = () => {
    html.classList.add("is-fonts-loaded");
};

const onImagesPreloaded = () => {
    html.classList.add("is-images-preloaded");
};

const onAllAssetsLoaded = () => {
    setTimeout(() => {
        html.classList.add("is-loaded");
        html.classList.add("is-first-loaded");
        html.classList.remove("is-loading");

        setTimeout(() => {
            html.classList.add("is-init");
            html.classList.add("is-ready");
        }, 200);
    }, 200);
};

////////////////
// Init
////////////////
function init() {
    // Load fonts
    window.isFontsLoaded = false;

    let fontsPromise = new Promise((resolve) => {
        fontsLoader(fonts, () => {
            // Callback
            onFontsLoaded?.();
            // Update modules
            requestAnimationFrame(() => {
                const fontsLoadedEvent = new CustomEvent("fontsLoaded");
                window.dispatchEvent(fontsLoadedEvent);
                window.isFontsLoaded = true;
            });
            // Resolve
            resolve();
        });
    });

    // When all assets are ready
    Promise.all([fontsPromise]).then(() => {
        // Callback
        onAllAssetsLoaded?.();
    });

    // Bind global events
    bindEvents();

    // Check mobile state
    window.isMobile = isMobile

    if (window.isMobile) {
        html.classList.add('is-mobile')
    }

    // First resize
    onResize();

    if (window.isMobile) {
        document.documentElement.style.setProperty(
            "--vh-initial",
            `${window.innerHeight * 0.01}px`
        );
    }

    // Globals
    globals();

    // Init modules
    app.init(app);

    // Debug focus
    // document.addEventListener(
    //     "focusin",
    //     function () {
    //         console.log('focused: ', document.activeElement)
    //     },
    //     true
    // );
}


////////////////
// Global events
////////////////
function bindEvents() {
    // Resize event
    const resizeEndEvent = new CustomEvent("resizeEnd");
    window.addEventListener(
        "resize",
        debounce(
            () => {
                onResize();
                window.dispatchEvent(resizeEndEvent);
            },
            200,
            false
        )
    );

    // Orientation change event
    window.addEventListener(
        "orientationchange",
        debounce(
            () => {
                onOnrientationChange();
            },
            200,
            false
        )
    );
}

function onOnrientationChange() {
    document.documentElement.style.setProperty(
        "--vh-initial",
        `${window.innerHeight * 0.01}px`
    );
}

function onResize() {
    let vw = html.offsetWidth * 0.01;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}

////////////////
// Execute
////////////////
window.onload = (event) => {
    const $style = document.getElementById('main-css');

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
};
